import { adminApiRequest, nestAdminApiRequest } from "../../utils/apiUtils";

export type AdVideoType = "PUB" | "TOURNAMENT";

export interface SolutionAdVideoResponse {
  id: number;
  type: AdVideoType;
  fileName: string;
  order: number;
}

export interface SolutionAdVideoRequest {
  type: AdVideoType;
  fileName: string;
  order: number;
  dates?: SolutionAdVideoDateRequest[];
}

export interface SolutionAdVideoUpdateRequest {
  type?: AdVideoType;
  fileName?: string;
  order?: number;
  dates?: SolutionAdVideoDateRequest[];
}

export interface SolutionAdVideoOrderItemRequest {
  id: number;
  order: number;
}

export interface SolutionAdVideoDateRequest {
  startDate: string;
  endDate: string;
}

export const SolutionAdVideoAPI = {
  getSolutionAdVideoList: (type: AdVideoType) => {
    return adminApiRequest
      .get("/solution-ad-video/list", { params: { type } })
      .then((res) => res);
  },

  getSolutionAdVideo: (id: number) => {
    return adminApiRequest.get(`/solution-ad-video/${id}`).then((res) => res);
  },

  createSolutionAdVideo: (request: SolutionAdVideoRequest) => {
    return adminApiRequest
      .post("/solution-ad-video", request)
      .then((res) => res);
  },

  updateSolutionAdVideo: (
    id: number,
    request: SolutionAdVideoUpdateRequest,
  ) => {
    return adminApiRequest
      .put(`/solution-ad-video/${id}`, request)
      .then((res) => res);
  },

  updateSolutionAdVideoOrder: (request: SolutionAdVideoOrderItemRequest[]) => {
    return adminApiRequest
      .put("/solution-ad-video/order", request)
      .then((res) => res);
  },

  deleteSolutionAdVideo: (id: number) => {
    return adminApiRequest
      .delete(`/solution-ad-video/${id}`)
      .then((res) => res);
  },
};
